import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { floorApi } from '../api/floorApi'
import type { Floor } from '../types/floor'

export function useGetFloor(buildingId: string, id: string, enabled = true) {
  return useQuery({
    queryKey: ['floor', id],
    queryFn: () => floorApi.getFloor(buildingId, id),
    enabled: enabled && !!buildingId && !!id,
    retry: false,
    refetchOnWindowFocus: false,
  })
}

export function useCreateFloor() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ buildingId, payload }: { buildingId: string; payload: Partial<Floor> }) =>
      floorApi.createFloor(buildingId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['building'] })
    },
  })
}

export function useUpdateFloor() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ buildingId, floorId, payload }: { buildingId: string; floorId: string; payload: Partial<Floor> }) =>
      floorApi.updateFloor(buildingId, floorId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['building'] })
    },
  })
}

export function useDeleteFloor() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ buildingId, floorId }: { buildingId: string; floorId: string }) =>
      floorApi.deleteFloor(buildingId, floorId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['building'] })
    },
  })
}
